import { BaseLayoutConfig } from '../shared/base-layout.config';
import { PublicLayout } from './public-layout.types';

export interface PublicLayoutConfig extends BaseLayoutConfig<PublicLayout> {}

export const defaultPublicLayoutConfig: PublicLayoutConfig = {
  layout: 'empty',
};
